<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 12C2 6.4768 6.4768 2 12 2C17.5232 2 22 6.47679 22 12C22 17.5221 17.5233 22 12 22C6.47672 22 2 17.5221 2 12ZM12 4C7.58136 4 4 7.58136 4 12C4 16.4177 7.58144 20 12 20C16.4185 20 20 16.4177 20 12C20 7.58137 16.4186 4 12 4Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.1698 8.9843C16.5603 9.37483 16.5603 10.008 16.1698 10.3985L11.5521 15.0162C11.1616 15.4067 10.5286 15.4067 10.1381 15.0164L7.82821 12.7076C7.4376 12.3171 7.43746 11.684 7.82789 11.2934C8.21833 10.9027 8.8515 10.9026 9.24211 11.293L10.8448 12.895L14.7556 8.9843C15.1461 8.59378 15.7793 8.59378 16.1698 8.9843Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
